//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { EventColorEnum } from './Enums';

export class CalendarBirthdayEventDisplayItem extends ItemBase {
    Age: number | null = null;
    Color: EventColorEnum = EventColorEnum.Beach;
    Date: string = "1970-01-01T00:00:00";
    FirstName: string | null = null;
    FullName: string | null = null;
    LastName: string | null = null;
    StudentID: string | null = null;

    constructor(initializer?: Partial<CalendarBirthdayEventDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "CalendarBirthdayEventDisplayItem";
}
